import React, { Component } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import '../css/ShareDBDocTimeline.scss';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

import { getRevs } from '../resources/api';
import { withShareDB, json } from '../providers/ShareDBProvider';

class SharedbDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      presence: {},
      currentRev: 0,
      revisions: [],
      dayMarks: {},
    };
  }

  subscribe = () => {
    const { sharedb, docId, currentUser, noPresence } = this.props;
    getRevs(docId).then((response) => this.process(response.data));
  };

  process = (res) => {
    const beg = res.shift();
    if (!beg?.create?.data) {
      return;
    }
    const revisions = res.reduce(
      (acc, x) => {
        const result = json.type.apply(cloneDeep(acc[acc.length - 1][0]), x.op);
        return [...acc, [result, x.m]];
      },
      [[beg.create.data, beg.m]]
    );

    let previousDay = null;
    const dayMarks = revisions.reduce((acc, [data, meta], i) => {
      const day = Math.floor(meta.ts / (1000 * 60 * 60 * 24));
      const dateName = new Date(meta.ts)
        .toDateString()
        .split(' ')
        .slice(1, 3)
        .join(' ');
      if (day !== previousDay) {
        previousDay = day;
        acc[i] = dateName;
      }
      return acc;
    }, {});

    this.setState({ revisions, dayMarks });
  };

  componentDidMount() {
    this.subscribe();
  }

  render() {
    const { children } = this.props;
    const { currentRev, revisions, dayMarks } = this.state;
    if (revisions.length === 0) {
      return (
        <div
          className="flex align-center justify-center mt4"
          data-cy="loading-worksheet"
        >
          Loading...
        </div>
      );
    }

    const [data, meta] = revisions[currentRev];
    const modifyDate = new Date(meta.ts);
    const modifyDateString = `${modifyDate
      .toISOString()
      .slice(0, 10)} - ${modifyDate.toLocaleTimeString()}`;
    const username = data?.users[meta?.userId]?.name || (
      <strong>Anonymous User</strong>
    );

    return (
      <>
        {/* TODO: Preferably this slider would be pinned to the top of the page, and sliding
        it would scroll the page to the relevant change, which would require inspecting each
        op and jumping to the corresponding block component that renders it */}
        <div className="page px5 pt5 body">
          <h2 className="h2">Version history timeline</h2>
          <div className="">
            Drag the timeline to see the edits in the workbook as they were made
            by different users. The time shown is in your computer’s timezone.
          </div>
          <div className="mb5 mb2 body">
            Current viewing edit{' '}
            <strong>
              {currentRev + 1}/{revisions.length}
            </strong>{' '}
            on <strong>{modifyDateString}</strong> by{' '}
            <strong>{username}</strong>
          </div>
          <div className="mx4 pb4">
            <Slider
              value={currentRev}
              min={0}
              max={revisions.length - 1}
              marks={dayMarks}
              onChange={(e) => this.setState({ currentRev: e })}
            />
          </div>
          <div
            className="mt5 mb2"
            style={{ width: '100%', borderBottom: '1px solid lightgray' }}
          />
        </div>
        <div>
          {children({
            doc: {
              submitOp: (...args) => {
                console.log('Skipping submitOp in timeline view:', ...args);
              },
              data,
              on: () => {},
              presence: {},
              removeListener: () => {},
            },
            data,
            presence: {},
            readOnlyWorksheet: true,
          })}
        </div>
      </>
    );
  }
}

SharedbDoc.propTypes = {
  docId: PropTypes.string.isRequired,
  sharedb: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  noPresence: PropTypes.bool.isRequired,
  templateDataFromAuthoring: PropTypes.object,
};

export default withShareDB()(SharedbDoc);
